"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = require("prop-types");
var _Icon = _interopRequireDefault(require("../../Icon"));
var _constant = require("../../Theme/constant");
var RightArrowWrapper = _styledComponents.default.div.withConfig({
  displayName: "RightArrow__RightArrowWrapper",
  componentId: "sc-1ps6r91-0"
})(["position:absolute;top:0;bottom:0;display:inline-flex;z-index:1;align-items:center;right:8px;"]);
var RightArrowWrapperExpanded = _styledComponents.default.div.withConfig({
  displayName: "RightArrow__RightArrowWrapperExpanded",
  componentId: "sc-1ps6r91-1"
})(["position:absolute;top:0;bottom:0;display:inline-flex;z-index:1;align-items:center;right:0px;padding:8px;"]);
var RightArrowButton = _styledComponents.default.button.withConfig({
  displayName: "RightArrow__RightArrowButton",
  componentId: "sc-1ps6r91-2"
})(["background-color:rgba(0,0,0,0.72);cursor:", ";color:#ffffff;border:none;width:24px;height:24px;border-radius:50%;padding:0;"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var RightArrow = function RightArrow(_ref2) {
  var onClick = _ref2.onClick,
    disabled = _ref2.disabled,
    theme = _ref2.theme,
    expandCarouselArrowClickableArea = _ref2.expandCarouselArrowClickableArea;
  var handleClick = function handleClick(ev) {
    ev.stopPropagation();
    onClick(ev);
  };
  return expandCarouselArrowClickableArea ? /*#__PURE__*/_react.default.createElement(RightArrowWrapperExpanded, {
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(RightArrowButton, {
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "ChevronRightIcon",
    fontsize: "titleNormal",
    theme: theme,
    color: "default"
  }))) : /*#__PURE__*/_react.default.createElement(RightArrowWrapper, null, /*#__PURE__*/_react.default.createElement(RightArrowButton, {
    onClick: handleClick,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "ChevronRightIcon",
    fontsize: "titleNormal",
    theme: theme,
    color: "default"
  })));
};
RightArrow.propTypes = {
  onClick: _propTypes.func,
  disabled: _propTypes.bool,
  theme: _propTypes.string,
  expandCarouselArrowClickableArea: _propTypes.bool
};
RightArrow.defaultProps = {
  onClick: function onClick() {},
  disabled: false,
  theme: _constant.DEFAULT_THEME,
  expandCarouselArrowClickableArea: false
};
var _default = RightArrow;
exports.default = _default;